// components/showPic/showPic.js
import React, { useEffect } from "react";
import "./showPic.css";

const ShowPic = ({ src, alt, onClose }) => {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  if (!src) return null;

  return (
    <div className="showpic-overlay" onClick={onClose}>
      <div className={`showpic-container`} onClick={(e) => e.stopPropagation()}>
        <img
          src={src}
          alt={alt || "foto"}
          className={`showpic-img`}
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default ShowPic;
